<template>
<div class="intro-content" v-if="detailArray.length > 0 || tips"> 
    <!-- 景区 -->
    <div class="items" v-if="detailArray.length > 0">
        <div class="intro-wrapper" v-for="(item, index) in detailArray" :key="index">
            <div class="intro-item" v-if="item.id === 'description'" @click="handleTap(index)">
                <div class="icon">
                    <img class="brief-icon" v-if="siteId === '1'" src="@/assets/scenic/introduce-sentosa.svg" />
                    <img class="brief-icon" v-else src="@/assets/scenic/detail-introduce.svg" />
                </div>
                <span class="item-text brief-text"><span class="strong">{{ item.text }}:</span>
                    <v-clamp :max-lines="3" tag="span" ellipsis="...">{{ item.content }}
                        <span slot="after" slot-scope="scope" v-if="scope.clamped || scope.expanded">&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="open-btn" @click.stop="scope.toggle()">{{ scope.expanded ? $t('common.fold') : $t('common.unfold') }}</span>
                        </span>
                    </v-clamp>
                </span>
            </div>
            <div class="intro-item" v-else-if="item.id === 'time'" @click="handleTap(index)">
                <div class="icon">
                    <img class="time-icon" v-if="siteId === '1'" src="@/assets/scenic/time-sentosa.png" />
                    <img class="time-icon" v-else src="@/assets/scenic/detail-time.svg" />
                </div>
                <div class="item-view">
                    <div class="strong">{{ item.text }}:</div>
                    <div class="item-content">{{ item.content }}</div>
                </div>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'number'" @click="handleTap(index)">
                <div class="icon">
                    <img class="phone-icon" v-if="siteId === '1'" src="@/assets/scenic/phone-sentosa.svg" />
                    <img class="phone-icon" v-else src="@/assets/scenic/detail-phone.svg" />
                </div>
                <a class="item-view" :href="`tel:${item.content}`">
                    <div class="strong">{{ $t('poi.number') }}:</div>
                    <div class="phone item-content">{{ item.content }}</div>
                </a>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'website'" @click="handleTap(index)">
                <div class="icon">
                    <img class="web-icon" v-if="siteId === '1'" src="@/assets/scenic/website-sentosa.svg" />
                    <img class="web-icon" v-else src="@/assets/scenic/detail-website.svg" />
                </div>
                <a class="item-view" :href="item.content" target="_blank">
                    <div class="strong">{{ $t('poi.website') }}:</div>
                    <div class="item-content">{{ item.content }}</div>
                </a>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'usage'" @click="handleTap(index)">
                <div class="icon">
                    <img class="ticket-icon sentosa" v-if="siteId === '1'" src="@/assets/scenic/ticket-sentosa.svg" />
                    <img class="ticket-icon" v-else src="@/assets/scenic/detail-ticket.svg" />
                </div>
                <div class="item-view">
                    <div class="strong">{{ $t('poi.promotionNote') }}:</div>
                    <div class="item-content">{{ item.content }}</div>
                </div>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'traffic'" @click="handleTap(index)">
                <div class="icon">
                    <img class="bus-sentosa" v-if="siteId === '1'" src="@/assets/scenic/transport-sentosa.png" />
                    <img class="bus-icon" v-else src="@/assets/scenic/detail-transport.svg" />
                </div>
                <div class="item-view">
                    <div class="strong">{{ $t('poi.traffic') }}:</div>
                    <div class="item-content" :class="{'en-traffic': $i18n.locale === 'en'}">{{ item.content }}</div>
                </div>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'ticket'" @click="handleTap(index)">
                <div class="icon">
                    <img class="ticket-sentosa" v-if="siteId === '1'" src="@/assets/scenic/ticket-sentosa.svg" />
                    <img class="ticket-icon" v-else src="@/assets/scenic/detail-ticket.svg" />
                </div>
                <div class="item-view">
                    <div class="strong">{{ $t('poi.ticket') }}:</div>
                    <div class="item-content">{{ item.content }}</div>
                </div>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'recommend'" @click="handleTap(index)">
                <div class="icon">
                    <img class="recommend-icon" v-if="siteId === '1'" src="@/assets/scenic/recommend-sentosa.svg" />
                    <img class="recommend-icon" v-else src="@/assets/scenic/detail-gonglue.svg" />
                </div>
                <div class="item-view">
                    <div class="strong">{{ $t('poi.recommend') }}:</div>
                    <div class="item-content">{{ $i18n.locale === 'en' ? 'Visiting ' : '' }}{{ item.content }}</div>
                </div>
                <div class="trigger">
                    <img src="@/assets/scenic/arrow-grey.svg" />
                </div>
            </div>
            <div class="intro-item" v-else-if="item.id === 'address'" @click="handleNavigate">
                <div class="icon">
                    <img class="address-icon" v-if="siteId === '1'" src="@/assets/scenic/address-sentosa.svg" />
                    <img class="address-icon" v-else src="@/assets/scenic/detail-address.svg" />
                </div>
                <div class="address-text item-view">
                    <div class="strong">{{ $t('poi.address') }}:</div>
                    <div class="item-content">{{ item.content }}</div>
                </div>
                <div class="trigger address">
                    <img src="@/assets/scenic/nav-sentosa.svg" v-if="siteId === '1'" class="navigate-sentosa" />
                    <img src="@/assets/scenic/detail-nav.svg" v-else class="navigate-icon" />
                </div>
            </div>
        </div>
    </div>
    <div class="reminder" v-if="tips" :style="detailArray.length > 0 ? 'margin-top: 12px' : ''">
        <span class="note-title">{{ $t('poi.tips') }}:</span>
        <span class="note-text">{{ tips }}</span>
        <div class="reminder-btn" @click="displayReminder" v-if="showMore">{{ $t('poi.expandAll') }}</div>
    </div>
    <v-reminder ref="reminder" siteType="siteType" :content="site.tips" />
</div>
</template>

<script>
import Reminder from '@/components/scenic/Reminder.vue'
import VClamp from 'vue-clamp'

export default {
    data () {
        return {
            siteId: '1',
            expanded: false,
            appid: app.appid,
            typeMap: {
                site: 'Site',
                show: 'ShowItem',
                event: 'SiteActivity',
                hotel: 'Hotel',
                mall: 'SiteShop',
                merchant: 'Merchant',
                promotion: 'PoiPromotion'
            },
            currentEnv: null
        }
    },
    computed: {
        shortDes () {
            const desc = this.detailArray.find(item => item.id === 'description')
            if (desc.content.length > 76) {
                return desc.content.slice(0, 76) + '...'
            } else {
                return desc.content
            }
        },
        tips () {
            // 处理温馨提示
            if (this.site.tips) {
                if (this.site.tips.length > 40) {
                    return this.site.tips.slice(0, 40) + '...'
                } else {
                   return this.site.tips
                }
            } else {
                return ''
            }
        },
        showMore () {
            return this.site.tips.length > 40
        }
    },
    props: {
        detailArray: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        site: {
            type: Object,
            default: () => {
                return {}
            }
        },
        siteType: {
            type: String,
            default: 'site'
        } 
    },
    components: {
        'v-reminder': Reminder,
        'v-clamp': VClamp
    },
    created () {
        const currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
        this.currentEnv = currentEnv
    },  
    methods: {
        // 点击跳转到游玩指南
        handleTap (index) {
            const guideArray = this.detailArray
            guideArray.forEach((item, order) => {
                if (order === index) {
                    item.selected = true
                } else {
                    item.selected = false
                }
            })
            this.$store.commit('SET_GUIDE_ARRAY', guideArray)
            let url = '/playGuide'
            if (this.$route.query.language === 'zh') url += '?language=zh'
            this.$router.push(url)
        },
        handleNavigate () {
            const type = this.typeMap[this.siteType]
            const routeArray = ['', '', '', '', '', this.site.lon, this.site.lat, this.site.name, type, this.site.id]
            console.log(routeArray)
            if (this.currentEnv) {
                wx.navigateTo({
                    url: `/packageScenic/pages/navigateWeb/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
                })
            } else {
                this.askForPermission()
                // let url = `/navigateweb/${encodeURIComponent(JSON.stringify(routeArray))}?siteId=1`
                // if (this.$route.query.language === 'zh') url += '&language=zh'
                // this.$router.push(url)
                let url = '/navigateweb'
                let params = { siteId: 1, data: encodeURIComponent(JSON.stringify(routeArray)) }
                if (this.$route.query.language === 'zh') Object.assign(params, { language: 'zh' })
                this.$store.commit('SET_DIRECT', true)
                this.$router.push({
                    path: url, query: params
                })
            }
        },
        handleExpand () {
            this.expanded = !this.expanded
        },
        // 显示温馨提示
        displayReminder () {
            this.$refs.reminder.show()
        },
        askForPermission () {
            if (typeof DeviceOrientationEvent.requestPermission === 'function') {
                DeviceOrientationEvent.requestPermission().then(permissionState => {
                if (permissionState === 'granted') {
                    // window.addEventListener('deviceorientation', this.handleOrientation)
                }
                }).catch(err => {
                this.toast = this.$createToast({
                    time: 1500,
                    type: 'txt',
                    txt: this.$t('common.orientationMsg')
                })
                this.toast.show()
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.intro-content {
    padding: 14px 12px 20px;
    color: #666666;
    font-size: 14px;
    border-bottom: 8px solid #f0f0f0;
    line-height: 1.5em;
}
  
.intro-content .intro-item {
    display: flex;
    padding: 6px 26px 6px 0;
    position: relative;
}
  
.intro-item .phone {
    text-decoration: underline;
}
  
.intro-content .brief-icon {
    width: 14px;
    height: 15px;
}
  
.intro-content .time-icon {
    width: 16px;
    height: 16px;
}
  
.intro-content .phone-icon {
    width: 15px;
    height: 16px;
}
  
.intro-content .ticket-icon {
    width: 18px;
    height: 16px;
}

.intro-content .ticket-sentosa {
    width: 17px;
    height: 14px;
}
  
.intro-content .recommend-icon {
    width: 16px;
    height: 18px;
}

.intro-content .bus-icon {
    width: 16px;
    height: 15px;
}

.intro-content .bus-sentosa {
    width: 15px;
    height: 16px;
}
  
.intro-content .address-icon {
    width: 18px;
    height: 18px;
}

.intro-content .web-icon {
    width: 17px;
    height: 17px;
}
  
.intro-content .icon {
    width: 21px;
    height: 18px;
    flex-shrink: 0;
    margin-right: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
}
  
/* .intro-content image.time {
    width: 32rpx;
    height: 32rpx;
    top: 4rpx;
    margin-right: 8rpx;
} */
  
.intro-item .item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.2s ease-out;
}

.intro-item .item-view {
    display: flex;
}

.intro-item .item-content {
    max-width: 225px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.intro-item .item-content.en-traffic {
    max-width: 225px;
}
  
.intro-item .brief-text {
    white-space: normal;
}
  
.intro-item .strong {
    font-weight: bold;
    font-family: GothamBold;
    margin-right: 7px;
    color: #222125;
    flex-shrink: 0;
}

.intro-item .address-text .item-content {
    white-space: initial;
    overflow: initial;
}
  
.intro-item .trigger {
    align-self: center;
    position: absolute;
    right: -12px;
    top: 50%;
    margin-top: -19px;
    width: 31px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.intro-item .open-btn {
    position: absolute;
    right: 2px;
    bottom: 0;
    font-weight: bold;
    font-family: GothamBold;
    z-index: 5;
    padding: 6px 8px;
}

.trigger.address {
    top: 0;
    margin-top: 0;
}
  
.trigger img {
    width: 6px;
    height: 12px;
    display: block;
    margin: 0;
}

.trigger .navigate-icon {
    width: 18px;
    height: 19px;
}

.trigger .navigate-sentosa {
    width: 16px;
    height: 16px;
}

.intro-content .note-title {
    font-weight: bold;
    font-family: GothamBold;
    margin-right: 6px;
    flex-shrink: 0;
}
  
.intro-content .note-text {
    display: -webkit-box !important;
    white-space: pre-wrap;
    word-break: break-word;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
  
.intro-content .reminder {
    border-radius: 8px;
    background-color: rgba(55, 188, 235, 0.7);
    font-size: 12px;
    color: #ffffff;
    padding: 12px;
    position: relative;
    display: flex;
}
  
.intro-content .reminder-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #f8a909;
    font-weight: bold;
    font-family: GothamBold;
    padding: 12px;
}
</style>